// Known browser-extension "site" adapters — mirrors the backend catalogue
// at server/app/core/extension_sites.py KNOWN_EXTENSION_SITES. Add a new
// entry here the same day its chrome-extension/sites/<id>.js adapter ships
// so SuperAdmin can grant it per tenant.
//
// `description`/`usage` are consumed by the end-user Browser Extension page
// (pages/admin/chrome-extension/index.jsx) to explain what the extension
// actually does per site, and how to trigger it — kept here, not hardcoded
// on that page, specifically so a new site is a one-entry addition, not a
// page rewrite. `value`/`label` are the only fields the SuperAdmin
// entitlement checkbox list (AddEditModel.jsx) reads.
export const EXTENSION_SITE_OPTIONS = [
  {
    value: "linkedin",
    label: "LinkedIn",
    description: "Send outreach messages and save candidate profiles into your campaigns, directly from LinkedIn.",
    usage: "Open a LinkedIn profile or messages page — the TalentFlow button appears automatically.",
  },
];

export const DEFAULT_ENABLED_EXTENSION_SITES = ["linkedin"];
